<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div>
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div class="bg-white dark:bg-transparent">
      <div class="mx-auto max-w-7xl py-8 px-4 sm:py-10 sm:px-6 lg:px-8">
        <div class="text-center">
          <h2
            class="text-ontick-green-600 text-base font-semibold uppercase tracking-wide"
          >
            Sugestão do desenvolvedor
          </h2>
          <p
            class="text-ontick-carbon-900 mt-1 text-4xl font-extrabold dark:text-gray-300 sm:text-5xl sm:tracking-tight lg:text-4xl"
          >
            Diminua seu risco, diversifique!
          </p>
          <p
            class="mx-auto mt-5 max-w-xl text-xl text-gray-500 dark:text-gray-400"
          >
            O portfólio tem como função a distribuição do risco e balanceamento
            da carteira
          </p>
        </div>
      </div>
    </div>

    <div class="px-4 sm:px-6 lg:px-8">
      <div class="sm:flex sm:items-center"></div>
      <div
        class="mx-auto max-w-7xl py-16 px-4 sm:px-6 sm:pb-24 sm:pt-8 lg:px-8"
      >
        <div class="px-4 sm:px-6 lg:px-8">
          <div class="mt-2 flex flex-col">
            <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div
                class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8"
              >
                <div
                  class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
                >
                  <table class="min-w-full">
                    <thead class="dark:bg-ontick-steel-500 bg-white">
                      <tr>
                        <th
                          scope="col"
                          class="text-ontick-carbon-900 py-3.5 pl-4 pr-3 text-left text-sm font-semibold dark:text-gray-300 sm:pl-6"
                        >
                          Estratégia
                        </th>
                        <th
                          scope="col"
                          class="text-ontick-carbon-900 px-3 py-3.5 text-left text-sm font-semibold dark:text-gray-300"
                        >
                          Ativo
                        </th>
                        <th
                          scope="col"
                          class="text-ontick-carbon-900 px-3 py-3.5 text-left text-sm font-semibold dark:text-gray-300"
                        >
                          Peso*
                        </th>
                      </tr>
                    </thead>
                    <tbody class="dark:bg-ontick-graphite-500 bg-white">
                      <template v-for="(location, index) in locations">
                        <tr
                          class="dark:border-ontick-steel-500 border-t border-gray-200"
                          :key="location.name + index"
                        >
                          <th
                            colspan="5"
                            scope="colgroup"
                            class="dark:bg-ontick-graphite-500 text-ontick-carbon-900 bg-gray-50 px-4 py-2 text-left text-xl font-semibold dark:text-gray-300 sm:px-6"
                          >
                            {{ location.name }}
                          </th>
                        </tr>
                        <tr
                          v-for="(person, personIdx) in location.people"
                          :key="location.name + person.name + personIdx"
                          :class="[
                            personIdx === 0
                              ? 'dark:border-ontick-steel-400 border-gray-300'
                              : 'dark:border-ontick-steel-500 border-gray-200',
                            'border-t',
                          ]"
                        >
                          <td
                            class="text-ontick-carbon-900 whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium dark:text-gray-300 sm:pl-6"
                          >
                            {{ person.name }}
                          </td>
                          <td
                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 dark:text-gray-400"
                          >
                            {{ person.title }}
                          </td>
                          <td
                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 dark:text-gray-400"
                          >
                            {{ person.email }}
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <p class="text-ontick-carbon-900 pt-4 text-sm dark:text-gray-300">
            *Múltiplo da quantidade de mini-contratos.
          </p>
          <p class="text-ontick-carbon-900 pt-4 text-sm dark:text-gray-300">
            <strong>Disclaimer:</strong> O portfólio tem como objetivo
            distribuir o risco e equilibrar a carteira, evitando modificações
            aleatórias. No entanto, é importante estar ciente dos riscos e
            possíveis perdas associados à renda variável. Os resultados passados
            não garantem rendimentos futuros e os investimentos podem sofrer
            perdas. Não há garantia de sucesso das estratégias discutidas e o
            desempenho passado de qualquer investimento ou estratégia de
            investimento não é indicativo de resultados futuros ou desempenho
            futuro.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locations: [
        {
          name: "Portfólio Baby",
          people: [
            { name: "XRocket", title: "WIN", email: "1x" },
            { name: "R2", title: "WIN", email: "1x" },
            { name: "H1 Sombra", title: "WIN", email: "1x" },
            { name: "R Reverso", title: "WIN", email: "1x" },
            { name: "XOne", title: "WIN", email: "1x" },
          ],
        },

        {
          name: "Portfólio Start",
          people: [
            { name: "RDólar", title: "WDO", email: "1x" },
            { name: "XRocket", title: "WIN", email: "1x" },
            { name: "R2", title: "WIN", email: "2x" },
            { name: "RR", title: "WIN", email: "1x" },
            { name: "XOne", title: "WIN", email: "1x" },
          ],
        },

        {
          name: "Portfólio Plus",
          people: [
            { name: "RDólar", title: "WDO", email: "1x" },
            { name: "H1 Sombra", title: "WIN", email: "3x" },
            { name: "XRocket", title: "WIN", email: "3x" },
            { name: "R2", title: "WIN", email: "4x" },
            { name: "R Reverso", title: "WIN", email: "3x" },
            { name: "XOne", title: "WIN", email: "3x" },
          ],
        },
        // More people...
      ],
    };
  },
};
</script>
